import React from "react";
import { BarChart3, LineChart, Users, LinkIcon, Sparkles, FileDown, Lock } from "lucide-react";

const SECTIONS = [
  { icon: BarChart3, title: "Collaboration overview & deliverables", desc: "Each partnership with what you delivered." },
  { icon: LinkIcon, title: "Content links", desc: "Direct links to the posts and videos you made." },
  { icon: LineChart, title: "Views, reach & engagement", desc: "Where available from connected accounts." },
  { icon: Users, title: "Audience insights", desc: "Age, location and interests, where available." },
  { icon: Sparkles, title: "Campaign highlights & notes", desc: "Your standout results, in your words." },
  { icon: FileDown, title: "Shareable PDF report", desc: "One tidy report to send to brands." },
];

export function PerformanceReportsComingSoon() {
  return (
    <section data-testid="performance-reports-coming-soon" className="rounded-3xl border border-indigo-200 bg-gradient-to-br from-indigo-50 to-white p-6">
      <div className="flex flex-wrap items-center gap-3">
        <h2 className="font-display text-2xl font-bold text-zinc-900">Performance Reports</h2>
        <span data-testid="perf-coming-soon-badge" className="inline-flex items-center gap-1 rounded-full bg-indigo-600 px-3 py-1 text-xs font-semibold text-white"><Lock className="h-3 w-3" /> Coming soon</span>
        <span className="rounded-full bg-indigo-100 px-2.5 py-0.5 text-xs font-medium text-indigo-700">Planned for Creator Pro</span>
      </div>
      <p className="mt-2 max-w-2xl text-zinc-600">Turn your collaboration results into a professional report to share with brands. We’re working on a simple way to bring your content results and campaign highlights together.</p>

      <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {SECTIONS.map((s) => {
          const Icon = s.icon;
          return (
            <div key={s.title} className="rounded-2xl border border-indigo-100 bg-white/70 p-4">
              <Icon className="h-5 w-5 text-indigo-500" />
              <p className="mt-2 text-sm font-semibold text-zinc-800">{s.title}</p>
              <p className="mt-0.5 text-xs text-zinc-500">{s.desc}</p>
            </div>
          );
        })}
      </div>

      <div className="mt-5 rounded-2xl border border-dashed border-indigo-200 bg-white/60 p-4">
        <p className="text-xs font-semibold uppercase tracking-wide text-indigo-400">Illustrative sample — not real data</p>
        <div className="mt-2 grid grid-cols-3 gap-3 opacity-70">
          {[["Reach", "18,400"], ["Engagement", "7.2%"], ["Content pieces", "6"]].map(([l, v]) => (
            <div key={l} className="rounded-xl bg-indigo-50 p-3 text-center"><p className="text-lg font-bold text-indigo-900">{v}</p><p className="text-[11px] text-indigo-500">{l}</p></div>
          ))}
        </div>
      </div>

      <p className="mt-4 text-xs text-zinc-400">Performance Reports aren’t available yet. Sample figures above are illustrative only and are not from any real account.</p>
    </section>
  );
}
